import React, { useEffect, useState } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import CustomBtn from "../../../components/Buttons/CustomBtn";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { LabourColumns } from "../../../assets/Columns/LabourColumns";
import { useDispatch, useSelector } from "react-redux";
import { fetchLabours } from "../../../store/Slices/LabourSlice";
import CreateLabourModal from "../../../components/Modals/CreateLabourModal";
import EditLabourModal from "../../../components/Modals/EditLabourModal";
import DeleteModal from "../../../components/Modals/DeleteModal";
import { DeleteLaboursByIdApi } from "../../../ApiRequests";
import { ErrorToast, SuccessToast } from "../../../utils/ShowToast";
import FetchingLoading from "../../../components/Loaders/FetchingLoading";

const Labour = () => {
  const [SearchText, setSearchText] = useState("");
  const [OpenModal, setOpenModal] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");

  const dispatch = useDispatch();
  const Labours = useSelector((state) => state.Labours);

  useEffect(() => {
    dispatch(fetchLabours());
  }, [dispatch]);

  return (
    <BodyWrapper>
      <Header title={"Labour"} desc="Manage your labour effectively">
        <CustomBtn title={"Pay Sallary"} onClick={() => {}} />
        <CustomBtn
          title={"Create New"}
          onClick={() => {
            setOpenModal(true);
          }}
        />
      </Header>
      <div className="w-full mt-10 flex justify-center items-center">
        {Labours.data && (
          <SearchableTable
            setOpenEditModal={setOpenEditModal}
            setOpenDeleteModal={setOpenDeleteModal}
            setSelected={setSelected}
            SearchPlaceholder={"Search Labour Name..."}
            SearchText={SearchText}
            setSearchText={setSearchText}
            CurrentData={Labours.data}
            //   CurrentData={CategoryState.data.filter((dt) =>
            //     SearchText === ""
            //       ? true
            //       : dt.title.toLowerCase().startsWith(SearchText.toLowerCase())
            //   )}
            Columns={LabourColumns}
          />
        )}
      </div>
      {OpenModal && (
        <CreateLabourModal Open={OpenModal} setOpen={setOpenModal} />
      )}

      {OpenEditModal && (
        <EditLabourModal
          Open={OpenEditModal}
          setOpen={setOpenEditModal}
          currentLabour={Selected}
        />
      )}
      {OpenDeleteModal && (
        <DeleteModal
          Open={OpenDeleteModal}
          setOpen={setOpenDeleteModal}
          Loading={Loading}
          onSubmit={async () => {
            setLoading(true);
            try {
              const response = await DeleteLaboursByIdApi(Selected._id);
              if (response.data.success) {
                setOpenDeleteModal(false);
                SuccessToast("Labour delete successfully");
                dispatch(fetchLabours());
              } else {
                ErrorToast(response.data.error?.msg);
              }
            } catch (err) {
              console.log(err);
              ErrorToast("Failed to delete Labour!");
            }
            setLoading(false);
          }}
        />
      )}
    </BodyWrapper>
  );
};

export default Labour;
